<template>
  <div class="columns">
    <div class="column">
      <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Answers:</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <b-field v-for="(choice, index) of answers" :key="index" style="margin-bottom: -8px">
                <b-radio-button
                  :native-value="index"
                  v-model="correctAnswer"
                  type="is-success"
                  :disabled="choice.value === ''"
                >
                  <span>
                     Right answer?
                  </span>
                </b-radio-button>

                <b-input
                  type="text"
                  v-model="choice.value"
                  placeholder="Click to add another answer"
                  expanded
                  maxlength="80"
                >
                </b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'MultiChoiceAnswers',
    data() {
      return {
        answers: [{ value: '' }, { value: '' }],
        correctAnswer: null,
      }
    },
    watch: {
      answers: {
        handler: function (val) {
          this.setAnswers(val)
          const emitObject = {
            answers: this.answers,
            correctAnswer: this.correctAnswer
          }
          this.$emit('updated', emitObject)
        },
        deep: true,
      },
      correctAnswer: {
        handler: function () {
          const emitObject = {
            answers: this.answers,
            correctAnswer: this.correctAnswer
          }
          this.$emit('updated', emitObject)
        }
      }
    },
    methods: {
      /*
        Expected format:
        {
          "answers": {
            "1": "MultiR11",
            "2": "MultiR12", // good one
            "3": "MultiR13"
          },
          "correctAnswer": "2",
       }
       */
      init(val) {
        if (val.answers) {
          this.answers = Object.keys(val.answers)
            .map(k => {
              return { value: val.answers[k] }
            })
        }
        if (val.correctAnswer) {
          this.correctAnswer = parseInt(val.correctAnswer) - 1
        }
      },
      setAnswers(val) {
        if (this.answers) {
          if (val[val.length - 1] && val[val.length - 1].value) {
            this.answers.push({value: ''})
          } else if (val.length > 1 && val[val.length - 1].value === '' && val[val.length - 2].value === '') {
            this.answers.splice(val.length - 1, 1)
          }
          if (this.correctAnswer !== null && this.answers[this.correctAnswer] && this.answers[this.correctAnswer].value === '') {
            this.correctAnswer = null
          }
        }
      },
      clearForm() {
        this.answers = [{
          value: '',
        }, {
          value: '',
        }]
        this.correctAnswer = null
      }
    }
  }
</script>

<style scoped>
  .field-label {
    flex-grow: 0;
  }
  .field-label label {
    width: 180px !important;
  }
</style>
